import React from 'react';
import { useTranslation } from 'react-i18next';

export default function useCustomTranslation(token, interpolation_hash: {}) {
  const { t } = useTranslation();

  const ret = (token) => {
    const translated_text = t(token, interpolation_hash)

    if (translated_text != null) {
      let split_on_linebreak = translated_text.split('\\n')
      // style={{backgroundColor: 'green', color: 'white'}}
      if (split_on_linebreak.length === 1) {
        return (
          <span>
          { translated_text }
          </span>
        )
      } else {
        return (
          <span>
            {translated_text.split('\\n').map(function(item, key) {
              return (
                <span key={key}>
                  {item}
                  <br/>
                </span>
              )
            })}
          </span>
        )
      }
    } else {
       return token
    }
  }

  return ret;
}



// WEBPACK FOOTER //
// ./src/hooks/useCustomTranslation.js